// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvarWizardResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/salvarWizard/{franquia_id}
 *
 * Returns the saved configuracao_franquia row after wizard submission —
 * same flat shape as /franquias/dashboard/{id} (one Configuracao_franquia_record
 * DB row). Declared as inline public properties (default getDados()) so the
 * generated runtime schema is concrete rather than empty `{}` — a bare
 * Row-typed `$dados` is classified as a primitive by the TS generator and
 * yields no runtime field map.
 *
 * Decimal columns (investimento_total, roe_desejado, meta_faturamento_*,
 * valor_medio_item) come back from MySQL as strings via CodeIgniter's default
 * driver — typed as ?string. Tinyint/int columns are coerced to int in the
 * controller (via Franquias_ConfiguracaoFranquiaRow::fromRow) before assignment.
 *
 * Field shape verified against the real captured payload of
 * POST /franquias/franquias/salvarWizard/{id} (FranquiasWizardConfigTest).
 *
 * @see Franquias_ConfiguracaoFranquiaRow for the shared single-row shape
 * @see Configuracao_franquia_model for getPorFranquia/salvar
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Franquias_SalvarWizardResponseDados {
franquia_id?: number
abre_sabado?: number
abre_domingo?: number
dias_uteis_padrao?: number
investimento_total?: string
roe_desejado?: string
capacidade_producao_diaria?: number
meta_producao_itens_dia?: number
valor_medio_item?: string
meta_faturamento_mensal?: string
meta_faturamento_anual?: string
mensagem_aniversariante?: string
mensagem_boas_vindas?: string
cnpj?: string
inscricao_estadual?: string
endereco?: string
numero?: string
complemento?: string
bairro?: string
cidade?: string
estado?: string
cep?: string
}

export type Franquias_SalvarWizardResponse = ApiResponse<Franquias_SalvarWizardResponseDados>;

registerResponseContract('Franquias_SalvarWizardResponse', {
  franquia_id:                { type: 'number',  required: false },
  abre_sabado:                { type: 'number',  required: false },
  abre_domingo:               { type: 'number',  required: false },
  dias_uteis_padrao:          { type: 'number',  required: false },
  investimento_total:         { type: 'string',  required: false },
  roe_desejado:               { type: 'string',  required: false },
  capacidade_producao_diaria: { type: 'number',  required: false },
  meta_producao_itens_dia:    { type: 'number',  required: false },
  valor_medio_item:           { type: 'string',  required: false },
  meta_faturamento_mensal:    { type: 'string',  required: false },
  meta_faturamento_anual:     { type: 'string',  required: false },
  mensagem_aniversariante:    { type: 'string',  required: false },
  mensagem_boas_vindas:       { type: 'string',  required: false },
  cnpj:                       { type: 'string',  required: false },
  inscricao_estadual:         { type: 'string',  required: false },
  endereco:                   { type: 'string',  required: false },
  numero:                     { type: 'string',  required: false },
  complemento:                { type: 'string',  required: false },
  bairro:                     { type: 'string',  required: false },
  cidade:                     { type: 'string',  required: false },
  estado:                     { type: 'string',  required: false },
  cep:                        { type: 'string',  required: false },
})
